import { useQuery } from '@tanstack/react-query';
import { ApiPropertyRepository } from '../../infrastructure/api/ApiPropertyRepository';
import { PropertySearchRequest } from '../../../public-map/domain/valueObjects/PropertySearchRequest';

const repository = new ApiPropertyRepository();

export function usePropertySearch(request: PropertySearchRequest) {
  const getQuery = useQuery({
    queryKey: [ 'propertySearch', request ],
    queryFn: () => repository.propertySearchRequest(request),
    enabled: !!request,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  return {
    properties: getQuery.data || [],
    error: getQuery.error || null,
    isLoading: getQuery.isLoading,
  };
}
